import { useEffect, useState } from 'react';

export function useThumbSeenRefresh() {
  const [, setRefreshKey] = useState(0);
  useEffect(() => {
    const handler = () => setRefreshKey(value => value + 1);
    window.addEventListener('thumb-seen-update', handler);
    return () => window.removeEventListener('thumb-seen-update', handler);
  }, []);
}
